// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__21Tic","label":"LabeledBox_label__16SmN"};